import { type MarqueeImage } from "@/data/marquee-images";
import s from "./style.module.css";
export interface Input extends MarqueeImage {
    index: number;
    onOpen?(): void;
    onClose?(): void;
}
static type OpenState = "open" | "opening" | "closed" | "closing";
static function isOpen(state: OpenState) {
    return state === "open" || state === "opening";
}
static function handleTransition(fn: () => void) {
    if (!document.startViewTransition) {
        fn();
        return { finished: Promise.resolve() };
    } else {
        return document.startViewTransition(fn);
    }
}
// Input
<const/{ id, index, onOpen, onClose }=input>
// State vars
<let/reduceMotion=false>
<let/openState=("closed" as OpenState)>
// Utilities
<const/toggleOpen=(nextOpen: boolean) => {
    if (!reduceMotion) {
        mainImage().style.viewTransitionName = `${id}-${index}`;
        dialogImage().style.viewTransitionName = `${id}-${index}`;
    }

    const { finished } = handleTransition(() => {
        if (nextOpen) {
            dialog().showModal();
            onOpen?.();
        } else {
            dialog().close();
        }
        openState = nextOpen ? "opening" : "closing";
    });

    finished.then(() => {
        if (!nextOpen) onClose?.();
        mainImage().style.viewTransitionName = "";
        dialogImage().style.viewTransitionName = "";
        openState = nextOpen ? "open" : "closed";
    });
}>

<button/trigger
    class=s.trigger
    aria-label="Open image lightbox"
    onClick() {
        toggleOpen(true);
    }>
    <img/mainImage
        class=s.mainImage
        src=input.src
        alt=input.alt
        draggable="false"
        style={
            display: isOpen(openState) ? "none" : "block",
            "aspect-ratio": input.aspectRatio,
        }>
</button>
<dialog/dialog
    class=s.dialog
    data-color=input.color
    onClick(e) {
        if (e.target === dialog()) {
            e.preventDefault();
            toggleOpen(false);
        }
    }
    onKeyDown(e) {
        if (openState.includes("ing")) {
            e.preventDefault();
        } else if (e.key === "Escape") {
            e.preventDefault();
            toggleOpen(false);
        }
    }>
    <img/dialogImage
        class=s.dialogImage
        style={ "aspect-ratio": input.aspectRatio }
        src=input.src
        alt=""
        draggable="false">
    <icon-button
        class=s.closeButton
        aria-label="close-modal"
        onClick() {
            toggleOpen(false);
        }>
        <icon-close-20/>
    </icon-button>
</dialog>

<script>
    reduceMotion = window.matchMedia(
        "(prefers-reduced-motion: reduce)",
    ).matches;
</script>
